/**
 * @module AWS CloudWatch RUM
 * @description Our Global AWS CloudWatch RUM Script
 */
import { AwsRum } from 'aws-rum-web';

const rumRegion = process.env.NEXT_PUBLIC_RUM_REGION;
const rumIdentityPoolId = process.env.NEXT_PUBLIC_RUM_IDENTITY_POOL_ID;
const rumClientId = process.env.NEXT_PUBLIC_RUM_CLIENT_ID;

/**
 * @function CloudWatchScript
 * @description AWS CloudWatch RUM Script
 */
export const CloudWatchScript = () => {
  try {
    const config = {
      sessionSampleRate: 1,
      identityPoolId: `us-east-1:${ rumIdentityPoolId }`,
      endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
      telemetries: [ 'http', 'errors', 'performance' ],
      allowCookies: true,
      enableXRay: true
    };

    const APPLICATION_ID = rumClientId;
    const APPLICATION_VERSION = '1.0.0';
    const APPLICATION_REGION = rumRegion;


    /* eslint-disable no-unused-vars */
    const awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config
    );
    /* eslint-enable no-unused-vars */
  } catch ( error ) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
};
